/**
 * Ajuda flutuante: uma nuvem acima do avatar (quiz · contato).
 * Chat = Inbox nativo (tt-inbox-dock).
 */
(function () {
  var root = document.querySelector('[data-tt-ajuda]');
  if (!root) return;

  var fab = root.querySelector('[data-tt-ajuda-fab]');
  var panel = root.querySelector('[data-tt-ajuda-panel]');
  var img = root.querySelector('[data-tt-ajuda-mascot]');
  var framesEl = root.querySelector('[data-tt-ajuda-frames]');
  if (!fab || !panel || !img || !framesEl) return;

  var frames = [];
  try {
    frames = JSON.parse(framesEl.textContent || '[]');
  } catch (e) {
    frames = [];
  }
  if (!frames.length) return;

  var prefetched = false;
  function prefetchFrames() {
    if (prefetched) return;
    prefetched = true;
    frames.forEach(function (src) {
      var preload = new Image();
      preload.src = src;
    });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var frameIdx = 0;
  var timer = null;
  var open = false;
  var INTERVAL = 90;

  function setFrame(i) {
    frameIdx = Math.max(0, Math.min(frames.length - 1, i));
    img.src = frames[frameIdx];
  }

  function stopAnim() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function playWaveOnce() {
    stopAnim();
    if (reduceMotion) {
      setFrame(frames.length - 1);
      return;
    }
    setFrame(0);
    timer = setInterval(function () {
      if (frameIdx >= frames.length - 1) {
        stopAnim();
        setFrame(frames.length - 1);
        return;
      }
      setFrame(frameIdx + 1);
    }, INTERVAL);
  }

  function openPanel() {
    open = true;
    root.classList.add('is-open');
    panel.hidden = false;
    fab.setAttribute('aria-expanded', 'true');
    fab.setAttribute('aria-label', 'Fechar ajuda');
    playWaveOnce();
  }

  function closePanel() {
    open = false;
    root.classList.remove('is-open');
    panel.hidden = true;
    fab.setAttribute('aria-expanded', 'false');
    fab.setAttribute('aria-label', 'Abrir ajuda');
    stopAnim();
    setFrame(0);
  }

  fab.addEventListener('click', function () {
    prefetchFrames();
    if (open) closePanel();
    else openPanel();
  });

  fab.addEventListener('mouseenter', function () {
    prefetchFrames();
    if (!open && !reduceMotion) playWaveOnce();
  });
  fab.addEventListener('mouseleave', function () {
    if (!open) {
      stopAnim();
      setFrame(0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) closePanel();
  });

  document.addEventListener('click', function (e) {
    if (!open) return;
    if (!root.contains(e.target)) closePanel();
  });

  var quizLink = root.querySelector('[data-tt-ajuda-quiz]');
  var contatoLink = root.querySelector('[data-tt-ajuda-contato]');
  if (quizLink) {
    quizLink.addEventListener('click', function () {
      closePanel();
    });
  }
  if (contatoLink) {
    contatoLink.addEventListener('click', function () {
      closePanel();
    });
  }
})();
